import React, { useState, useEffect, useRef } from 'react';
import './solutions.css';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import utmLogo from '../../assets/images/skyeairUTMLogo.svg';
import StackedCards from './StackedCards';
import Slider from 'react-slick';
import { useSelector } from 'react-redux';
import useGetUTMData from '../../Hooks/useGetUTMData';
import Questions from '../shared/questions/questions';
import Footer from '../shared/footer/footer';
import skyeairBlueLogo from "../../assets/icons/skyeairBlue.svg";
import SnackbarNav from '../main/SnackbarNav/SnackbarNav';
import MobileMenu from '../main/SnackbarNav/MobileMenu';
import useIsMobile from '../../Hooks/useIsMobile';
import ScrollToTopLink from '../../Utils/ScrollToTop';
import { Link } from 'react-router-dom';
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';
import Typewriter from './Typewriter';

gsap.registerPlugin(ScrollTrigger);

const Solutions = () => {
  const [headingData, setHeadingData] = useState({
  });

  const [features, setFeatures] = useState([]);
  const [bgLoaded, setBgLoaded] = useState(false);
  const [gifLoaded, setGifLoaded] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const totalSlides = features.length;
  const desc = `Skye UTM offers a streamlined portal for mission <span class="blue-text">planning</span> with 
  <span class="blue-text">real time</span> oversight for authorities.
  <span class="green-text">WhatsApp</span> integration enables easy 
  <span class="blue-text">mission creation</span>, simplifying end-to-end operations for efficient,
  compliant <span class="blue-text">deliveries</span> across industries.`;
  const navigate = (section) => {
    let url = '';
    switch (section) {
      case 'LOGIN':
        url = 'https://www.skyeutm.com/operator/operator-login';
        break;
      case 'GEOZONE':
        url = 'https://www.skyeutm.com/operator/operator-app/dashboard';
        break;
      case 'UTM-CONTACT':
        url = '/utm-contact';
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
        break;
      default:
        console.log(`Unknown section: ${section}`);
        return;
    }
    window.location.href = url;
  };

  useGetUTMData();
  const data = useSelector((store) => store.data.UTMData)
  useEffect(() => {
    if (data?.items) {
      data.items.forEach((ele) => {
        if (ele.Section === "Heading") {
          setHeadingData(ele.Content)
        }
        else if (ele.Section === "Features") {
          setFeatures(ele.Content.Features)
        }
      });
    }
  }, [data]);

  useEffect(() => {
    const handleResize = () => {
      setSlidesToShow(window.innerWidth < 480 ? 1 : 4);
    };
  
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const NextArrow = (props) => {
    const { onClick } = props;
    return (
      <div
        className="mobile-next-arrow"
        style={{
          display: 'block',
          background: 'rgb(121 121 121)',
          color: '#fff',
          padding: '10px',
          position: 'absolute',
          right: 12,
          zIndex: 2,
          top: '50%',
          cursor: 'pointer',
          transform: 'translateY(-50%)'
        }}
        onClick={onClick}
      >›</div>
    );
  };

  const PrevArrow = (props) => {
    const { onClick } = props;
    return (
      <div
        className="mobile-left-arrow"
        style={{
          display: 'block',
          background: 'rgb(121 121 121)',
          color: '#fff',
          padding: '10px',
          position: 'absolute',
          zIndex: 2,
          top: '50%',
          cursor: 'pointer',
          transform: 'translateY(-50%)'
        }}
        onClick={onClick}
      >‹</div>
    );
  };

  const [itemsToShow, setItemsToShow] = useState(window.innerWidth < 480 ? 1 : 4);
  // const [currentSlide, setCurrentSlide] = useState(0);
  const totalItems = features?.length;
 const [slidesToShow, setSlidesToShow] = useState(window.innerWidth < 480 ? 1 : 4);
  const lastVisibleItem = Math.min(Math.ceil(currentSlide + itemsToShow), totalItems);

  const sliderRef = useRef(null);
  const settings = {
    dots: true,
    infinite: true,
    speed: 1200,
    slidesToShow,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,                  
    autoplaySpeed: 2000,            
    pauseOnHover: true, 
    pauseOnFocus: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    beforeChange: (oldIndex, newIndex) => {
      setCurrentSlide(newIndex);
    },
    // afterChange: (index) => {
    //   if (index + slidesToShow >= totalItems) {
    //     setTimeout(() => {
    //       sliderRef.current?.slickGoTo(0);
    //     }, 500);
    //   }
    // },
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  const isMobile = useIsMobile();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleMouseEnter = () => {
    sliderRef.current?.slickPause();
  };
  
  const handleMouseLeave = () => {
    sliderRef.current?.slickPlay();
  };
  const visibleStart = currentSlide % totalItems;
  const visibleEnd = (visibleStart + slidesToShow - 1) % totalItems;
  const paddedTotal = String(totalItems).padStart(2, '0');
  const paddedStart = String(visibleStart + 1).padStart(2, '0');
  const paddedEnd = String(
    visibleEnd >= visibleStart
      ? visibleEnd + 1
      : (visibleEnd + 1) 
  ).padStart(2, '0');

  return (
    <div className="main">
      <div className="landing-header-container">
        <div className="landing-header pt-4">
          <div className="header-left">
          <Link to="/home"><img src={skyeairBlueLogo} alt="Skye UTM Logo" className="logo logo-heading" /></Link>
          </div>
          <div className="header-right">
            <button className="custom-btn-login btn btn-dark mobile-view" onClick={() => navigate('LOGIN')}>
              Log In
            </button>
          </div>
        </div>
      </div>

      <div className="main-landing-section">
        <div className="main-wrapper text-center px-3 pt-1">
          <img src={utmLogo} height="41" alt="Skye UTM Logo" className="logo-utm mb-2" />
          <h1 className="display-5 fw-bold tagline">{headingData?.TagLine}</h1>
          <p className="lead">
            {headingData?.Info}
          </p>

          {/* <div className="position-relative map-section">
            <img src={headingData?.ImageURL } className="rounded map-background" alt="Map" />
            <img className="mission-img" src={headingData?.GifURL} alt="Skye UTM Logo" />
          </div> */}

<div className="position-relative map-section">

{/* Background Image Skeleton */}
{!bgLoaded && <Skeleton height={300} width="100%" borderRadius="0.5rem" />}
<img
  src={headingData?.ImageURL}
  className={`rounded map-background ${bgLoaded ? 'd-block' : 'd-none'}`}
  alt="Map"
  onLoad={() => setBgLoaded(true)}
/>

{/* Foreground Gif Skeleton */}
{!gifLoaded && (
  <Skeleton
    height={100}
    width={100}
    circle
    className="position-absolute mission-img"
  />
)}
<img
  className={`mission-img ${gifLoaded ? 'd-block' : 'd-none'}`}
  src={headingData?.GifURL}
  alt="Skye UTM Logo"
  onLoad={() => setGifLoaded(true)}
/>
</div>


          <div className="main-zone-btn">
            <button className="custom-btn" onClick={() => navigate('GEOZONE')}>Geo Zone</button>
            <button className="custom-btn" onClick={() => navigate('UTM-CONTACT')} >Request a Demo</button>
          </div>
        </div>
      </div>


      <div className="awards-container">
        <h1 className="fw-bold text-center my-5 common-heading"> FEATURES</h1>
        <div style={{ width: '100%', maxWidth: '1145px', margin: '0 auto' }} 
         onMouseEnter={handleMouseEnter} 
         onMouseLeave={handleMouseLeave}
         >
          <Slider ref={sliderRef} {...settings} className="custom-slider-class">
            {features?.map((item, index) => (
              <div key={index} style={{ padding: '10px', marginRight: '25px' }} className="slide-wrapper">
                <div className="flip-card-inner" style={{ height: '340px' }} >
                  <div className="flip-card-front" style={{
                    border: '1px solid #ddd',
                    borderRadius: '10px',
                    minHeight: '150px',
                    padding: '10px'
                  }}>
                    <img src={item?.icon} alt="Icon" width="100%" style={{ height: '80px', objectFit: 'contain' }} />
                    <div className="carousel-heading-data">
                      <h6 className="text-left fw-bold" style={{ margin: '10px 0' }}>{item.Title}</h6>
                    </div>
                  </div>
                  <div className="flip-card-back" style={{
                    border: '1px solid #ddd',
                    borderRadius: '10px',
                    padding: '10px',
                    minHeight: '150px',
                    backgroundColor: '#f9f9f9'
                  }}>
                    <div className="back-text">
                      {item.Description}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>

        <div className="carousel-count" style={{ textAlign: 'right', marginTop: '33px', marginBottom: '5px', marginRight: '66px', fontWeight: 'bold' }}>
          {slidesToShow === 1
            ? `${paddedStart}/${paddedTotal}`
            : `${paddedEnd}/${paddedTotal}`}
        </div>
        </div>
      </div>

      <StackedCards />

      <div className="description-container">
        <h1 className="desc-heading">
          {/* Skye UTM offers a streamlined portal for mission <span className="blue-text">planning</span> with{' '}
          <span className="blue-text">real time</span> oversight for authorities.
          <span className="green-text">WhatsApp</span> integration enables easy{' '}
          <span className="blue-text">mission creation</span>, simplifying end-to-end operations for efficient,
          compliant <span className="blue-text">deliveries</span> across industries. */}

          <Typewriter text={desc} speed={10} />
        </h1>
      </div>

      <Questions source={'UTM'} />
      <Footer />

      <section>
        {!isMobile && <SnackbarNav />}
        {isMobile && !menuOpen && (
          <button className="menu-toggle" onClick={() => setMenuOpen(true)}>
            ☰
          </button>
        )}
        {isMobile && menuOpen && (
          <MobileMenu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />
        )}
      </section>
    </div>
  );
};

export default Solutions;